/**
 * Auto-generated from scripts/csv/input/main-categories.csv and categories.csv.
 * Do not edit manually — run `pnpm generate:classification-types`.
 */

export const WozMainCategoriesMap = {
  "primary": {
    "type": "primary",
    "code": "primary",
    "title": "Primaire kenmerken",
    "description": "Feitelijke objectgegevens",
    "priority": 1
  },
  "quality": {
    "type": "secondary",
    "code": "quality",
    "title": "Kwaliteit",
    "description": "Structurele/bouwkundige staat",
    "priority": 3
  },
  "maintenance": {
    "type": "secondary",
    "code": "maintenance",
    "title": "Onderhoud",
    "description": "Herstelbare mankementen",
    "priority": 4
  },
  "appearance": {
    "type": "secondary",
    "code": "appearance",
    "title": "Uitstraling",
    "description": "Esthetiek en visuele indruk",
    "priority": 7
  },
  "effectiveness": {
    "type": "secondary",
    "code": "effectiveness",
    "title": "Doelmatigheid",
    "description": "Functionele bruikbaarheid",
    "priority": 5
  },
  "amenities": {
    "type": "secondary",
    "code": "amenities",
    "title": "Voorzieningen",
    "description": "Installaties en faciliteiten",
    "priority": 2
  },
  "location": {
    "type": "secondary",
    "code": "location",
    "title": "Ligging",
    "description": "Omgevingsfactoren",
    "priority": 6
  },
  "energy": {
    "type": "secondary",
    "code": "energy",
    "title": "Energie",
    "description": "",
    "priority": 8
  },
  "legal": {
    "type": "legal",
    "code": "legal",
    "title": "Juridisch",
    "description": "",
    "priority": 9
  },
  "other": {
    "type": "other",
    "code": "other",
    "title": "Andere problemen",
    "description": "",
    "priority": 10
  }
} as const;

export const WozCategoriesMap = {
  "grief-primary-constructionYear": {
    "mainCategory": "primary",
    "platformCategoryCode": "grief-primary-constructionYear",
    "code": "grief-primary-constructionYear",
    "title": "Bouwjaar",
    "description": "Onjuist geregistreerd bouwjaar"
  },
  "grief-primary-objectType": {
    "mainCategory": "primary",
    "platformCategoryCode": "grief-primary-objectType",
    "code": "grief-primary-objectType",
    "title": "Soort bouw",
    "description": "Onjuist geregistreerd woningtype"
  },
  "grief-primary-outbuildings": {
    "mainCategory": "primary",
    "platformCategoryCode": "grief-primary-outbuildings",
    "code": "grief-primary-outbuildings",
    "title": "Bijgebouwen/Voorzieningen",
    "description": "Onjuist geregistreerde aanwezigheid, omvang of kwaliteit van bijgebouwen of voorzieningen"
  },
  "grief-primary-size": {
    "mainCategory": "primary",
    "platformCategoryCode": "grief-primary-size",
    "code": "grief-primary-size",
    "title": "Gebruiksoppervlakte",
    "description": "Onjuist geregistreerd gebruiksoppervlakte in vierkante meters (BAG-registratie)"
  },
  "grief-primary-plotSize": {
    "mainCategory": "primary",
    "platformCategoryCode": "grief-primary-plotSize",
    "code": "grief-primary-plotSize",
    "title": "Perceeloppervlakte",
    "description": "Onjuist geregistreerd perceelgrootte (BRK)"
  },
  "grief-primary-location": {
    "mainCategory": "primary",
    "platformCategoryCode": "grief-primary-location",
    "code": "grief-primary-location",
    "title": "Ligging",
    "description": "Onjuist geregistreerde ligging van het object of omgevingsfactoren die invloed hebben op de waarde"
  },
  "grief-secondary-quality": {
    "mainCategory": "secondary",
    "category": "quality",
    "platformCategoryCode": "grief-secondary-quality",
    "code": "grief-secondary-quality",
    "title": "Algemeen",
    "description": "Algemene bouwkundige kwaliteit"
  },
  "grief-secondary-quality-cracks": {
    "mainCategory": "secondary",
    "category": "quality",
    "platformCategoryCode": "grief-secondary-quality",
    "code": "grief-secondary-quality-cracks",
    "title": "Scheuren",
    "description": "Scheuren in muren, plafonds of fundering"
  },
  "grief-secondary-quality-subsidence": {
    "mainCategory": "secondary",
    "category": "quality",
    "platformCategoryCode": "grief-secondary-quality",
    "code": "grief-secondary-quality-subsidence",
    "title": "Verzakking",
    "description": "Verzakking van (of delen van) de woning"
  },
  "grief-secondary-quality-foundation": {
    "mainCategory": "secondary",
    "category": "quality",
    "platformCategoryCode": "grief-secondary-quality",
    "code": "grief-secondary-quality-foundation",
    "title": "Fundering",
    "description": "Funderingsproblemen (paalrot, betonrot)"
  },
  "grief-secondary-quality-wood-rot": {
    "mainCategory": "secondary",
    "category": "quality",
    "platformCategoryCode": "grief-secondary-quality",
    "code": "grief-secondary-quality-wood-rot",
    "title": "Houtrot in constructie",
    "description": "Houtrot in dragende constructies"
  },
  "grief-secondary-maintenance": {
    "mainCategory": "secondary",
    "category": "maintenance",
    "platformCategoryCode": "grief-secondary-maintenance",
    "code": "grief-secondary-maintenance",
    "title": "Algemeen",
    "description": "Algemene onderhoudsstaat"
  },
  "grief-secondary-maintenance-painting": {
    "mainCategory": "secondary",
    "category": "maintenance",
    "platformCategoryCode": "grief-secondary-maintenance",
    "code": "grief-secondary-maintenance-painting",
    "title": "Schilderwerk & kozijnen",
    "description": "Verf, kozijnen, ramen, deuren, boeidelen"
  },
  "grief-secondary-maintenance-roof": {
    "mainCategory": "secondary",
    "category": "maintenance",
    "platformCategoryCode": "grief-secondary-maintenance",
    "code": "grief-secondary-maintenance-roof",
    "title": "Dakbedekking",
    "description": "Dakpannen, bitumen, goten, lekkage dak"
  },
  "grief-secondary-maintenance-facade": {
    "mainCategory": "secondary",
    "category": "maintenance",
    "platformCategoryCode": "grief-secondary-maintenance",
    "code": "grief-secondary-maintenance-facade",
    "title": "Gevel & voegwerk",
    "description": "Voegen, stenen, gevelbekleding"
  },
  "grief-secondary-maintenance-moisture": {
    "mainCategory": "secondary",
    "category": "maintenance",
    "platformCategoryCode": "grief-secondary-maintenance",
    "code": "grief-secondary-maintenance-moisture",
    "title": "Vochtproblemen",
    "description": "Vocht, schimmel, condensatie"
  },
  "grief-secondary-maintenance-leak": {
    "mainCategory": "secondary",
    "category": "maintenance",
    "platformCategoryCode": "grief-secondary-maintenance",
    "code": "grief-secondary-maintenance-leak",
    "title": "Lekkages",
    "description": "Lekkende daken, leidingen, gevels"
  },
  "grief-secondary-maintenance-piping": {
    "mainCategory": "secondary",
    "category": "maintenance",
    "platformCategoryCode": "grief-secondary-maintenance",
    "code": "grief-secondary-maintenance-piping",
    "title": "Leidingwerk",
    "description": "Water, gas, elektra, riolering"
  },
  "grief-secondary-appearance": {
    "mainCategory": "secondary",
    "category": "appearance",
    "platformCategoryCode": "grief-secondary-appearance",
    "code": "grief-secondary-appearance",
    "title": "Algemeen",
    "description": "Algemene esthetische aspecten"
  },
  "grief-secondary-appearance-impoverishment": {
    "mainCategory": "secondary",
    "category": "appearance",
    "platformCategoryCode": "grief-secondary-appearance",
    "code": "grief-secondary-appearance-impoverishment",
    "title": "Verpaupering woning of straat",
    "description": "Verwaarloosde uitstraling woning/straat"
  },
  "grief-secondary-appearance-extension": {
    "mainCategory": "secondary",
    "category": "appearance",
    "platformCategoryCode": "grief-secondary-appearance",
    "code": "grief-secondary-appearance-extension",
    "title": "Aanbouw/uitbouw",
    "description": "Niet-passende of lelijke aanbouw"
  },
  "grief-secondary-appearance-architecture": {
    "mainCategory": "secondary",
    "category": "appearance",
    "platformCategoryCode": "grief-secondary-appearance",
    "code": "grief-secondary-appearance-architecture",
    "title": "Architectuur",
    "description": "Gedateerd ontwerp, niet passend in straat"
  },
  "grief-secondary-effectiveness": {
    "mainCategory": "secondary",
    "category": "effectiveness",
    "platformCategoryCode": "grief-secondary-effectiveness",
    "code": "grief-secondary-effectiveness",
    "title": "Algemeen",
    "description": "Algemene functionele aspecten"
  },
  "grief-secondary-effectiveness-layout": {
    "mainCategory": "secondary",
    "category": "effectiveness",
    "platformCategoryCode": "grief-secondary-effectiveness",
    "code": "grief-secondary-effectiveness-layout",
    "title": "Indeling",
    "description": "Onpraktische loop, inefficiënte ruimtes"
  },
  "grief-secondary-effectiveness-climate": {
    "mainCategory": "secondary",
    "category": "effectiveness",
    "platformCategoryCode": "grief-secondary-effectiveness",
    "code": "grief-secondary-effectiveness-climate",
    "title": "Binnenklimaat",
    "description": "Koud, warm, vochtig, donker"
  },
  "grief-secondary-effectiveness-accessibility": {
    "mainCategory": "secondary",
    "category": "effectiveness",
    "platformCategoryCode": "grief-secondary-effectiveness",
    "code": "grief-secondary-effectiveness-accessibility",
    "title": "Bereikbaarheid intern",
    "description": "Steile trap, geen lift (bij appartement)"
  },
  "grief-secondary-effectiveness-light": {
    "mainCategory": "secondary",
    "category": "effectiveness",
    "platformCategoryCode": "grief-secondary-effectiveness",
    "code": "grief-secondary-effectiveness-light",
    "title": "Lichtinval",
    "description": "Donkere kamers, weinig ramen"
  },
  "grief-secondary-amenities": {
    "mainCategory": "secondary",
    "category": "amenities",
    "platformCategoryCode": "grief-secondary-amenities",
    "code": "grief-secondary-amenities",
    "title": "Algemeen",
    "description": "Algemene voorzieningen"
  },
  "grief-secondary-amenities-central-heating-system": {
    "mainCategory": "secondary",
    "category": "amenities",
    "platformCategoryCode": "grief-secondary-amenities",
    "code": "grief-secondary-amenities-central-heating-system",
    "title": "CV-installatie",
    "description": "Ketel verouderd, defect, ontbreekt"
  },
  "grief-secondary-amenities-insulation": {
    "mainCategory": "secondary",
    "category": "amenities",
    "platformCategoryCode": "grief-secondary-amenities",
    "code": "grief-secondary-amenities-insulation",
    "title": "Isolatie",
    "description": "Spouw, dak, vloer, beglazing"
  },
  "grief-secondary-amenities-kitchen": {
    "mainCategory": "secondary",
    "category": "amenities",
    "platformCategoryCode": "grief-secondary-amenities",
    "code": "grief-secondary-amenities-kitchen",
    "title": "Keuken",
    "description": "Verouderde of gebrekkige keuken"
  },
  "grief-secondary-amenities-bathroom": {
    "mainCategory": "secondary",
    "category": "amenities",
    "platformCategoryCode": "grief-secondary-amenities",
    "code": "grief-secondary-amenities-bathroom",
    "title": "Badkamer",
    "description": "Verouderde of gebrekkige badkamer"
  },
  "grief-secondary-amenities-toilet": {
    "mainCategory": "secondary",
    "category": "amenities",
    "platformCategoryCode": "grief-secondary-amenities",
    "code": "grief-secondary-amenities-toilet",
    "title": "Toilet",
    "description": "Aantal, staat, locatie"
  },
  "grief-secondary-amenities-ventilation": {
    "mainCategory": "secondary",
    "category": "amenities",
    "platformCategoryCode": "grief-secondary-amenities",
    "code": "grief-secondary-amenities-ventilation",
    "title": "Ventilatie",
    "description": "Mechanische ventilatie, afzuiging"
  },
  "grief-secondary-amenities-electricity": {
    "mainCategory": "secondary",
    "category": "amenities",
    "platformCategoryCode": "grief-secondary-amenities",
    "code": "grief-secondary-amenities-electricity",
    "title": "Elektra",
    "description": "Groepen, aarding, stopcontacten"
  },
  "grief-secondary-amenities-sustainability": {
    "mainCategory": "secondary",
    "category": "amenities",
    "platformCategoryCode": "grief-secondary-amenities",
    "code": "grief-secondary-amenities-sustainability",
    "title": "Duurzaamheid",
    "description": "Zonnepanelen, warmtepomp ontbreekt"
  },
  "grief-secondary-location": {
    "mainCategory": "secondary",
    "category": "location",
    "platformCategoryCode": "grief-secondary-location",
    "code": "grief-secondary-location",
    "title": "Algemeen",
    "description": "Algemene Liggingsaspecten"
  },
  "grief-secondary-location-noise-traffic": {
    "mainCategory": "secondary",
    "category": "location",
    "platformCategoryCode": "grief-secondary-location",
    "code": "grief-secondary-location-noise-traffic",
    "title": "Geluidsoverlast verkeer",
    "description": "Auto's, trein, vliegtuig"
  },
  "grief-secondary-location-noise-commercial-activity": {
    "mainCategory": "secondary",
    "category": "location",
    "platformCategoryCode": "grief-secondary-location",
    "code": "grief-secondary-location-noise-commercial-activity",
    "title": "Geluidsoverlast Bedrijvigheid",
    "description": "Horeca, industrie, winkels"
  },
  "grief-secondary-location-noise-neighbours": {
    "mainCategory": "secondary",
    "category": "location",
    "platformCategoryCode": "grief-secondary-location",
    "code": "grief-secondary-location-noise-neighbours",
    "title": "Geluidsoverlast buren",
    "description": "Gehorige woning, lawaaierige buren"
  },
  "grief-secondary-location-noise-general": {
    "mainCategory": "secondary",
    "category": "location",
    "platformCategoryCode": "grief-secondary-location",
    "code": "grief-secondary-location-noise-general",
    "title": "Geluidsoverlast algemeen",
    "description": "Algemene geluidsoverlast"
  },
  "grief-secondary-location-odor": {
    "mainCategory": "secondary",
    "category": "location",
    "platformCategoryCode": "grief-secondary-location",
    "code": "grief-secondary-location-odor",
    "title": "Geuroverlast",
    "description": "Industrie, veehouderij, riool"
  },
  "grief-secondary-location-neighborhood": {
    "mainCategory": "secondary",
    "category": "location",
    "platformCategoryCode": "grief-secondary-location",
    "code": "grief-secondary-location-neighborhood",
    "title": "Buurt/wijk",
    "description": "Onveilig, verpaupering, criminaliteit"
  },
  "grief-secondary-location-traffic-situation": {
    "mainCategory": "secondary",
    "category": "location",
    "platformCategoryCode": "grief-secondary-location",
    "code": "grief-secondary-location-traffic-situation",
    "title": "Verkeerssituatie",
    "description": "Drukke weg, bereikbaarheid"
  },
  "grief-secondary-location-distance-amenities": {
    "mainCategory": "secondary",
    "category": "location",
    "platformCategoryCode": "grief-secondary-location",
    "code": "grief-secondary-location-distance-amenities",
    "title": "Afstand voorzieningen",
    "description": "Winkels, scholen, OV ver weg"
  },
  "grief-secondary-location-garden": {
    "mainCategory": "secondary",
    "category": "location",
    "platformCategoryCode": "grief-secondary-location",
    "code": "grief-secondary-location-garden",
    "title": "Tuin",
    "description": "Grootte, ligging, bezonning, ontbreekt"
  },
  "grief-secondary-location-parking": {
    "mainCategory": "secondary",
    "category": "location",
    "platformCategoryCode": "grief-secondary-location",
    "code": "grief-secondary-location-parking",
    "title": "Parkeren",
    "description": "Geen oprit, parkeerdruk straat"
  },
  "grief-secondary-location-privacy": {
    "mainCategory": "secondary",
    "category": "location",
    "platformCategoryCode": "grief-secondary-location",
    "code": "grief-secondary-location-privacy",
    "title": "Uitzicht/privacy",
    "description": "Slecht uitzicht, inkijk"
  },
  "grief-secondary-location-soil": {
    "mainCategory": "secondary",
    "category": "location",
    "platformCategoryCode": "grief-secondary-location",
    "code": "grief-secondary-location-soil",
    "title": "Bodem",
    "description": "Verontreiniging, grondwater"
  },
  "grief-secondary-location-flooding": {
    "mainCategory": "secondary",
    "category": "location",
    "platformCategoryCode": "grief-secondary-location",
    "code": "grief-secondary-location-flooding",
    "title": "Wateroverlast",
    "description": "Overstromingsrisico, hoge grondwater"
  },
  "grief-secondary-location-masts": {
    "mainCategory": "secondary",
    "category": "location",
    "platformCategoryCode": "grief-secondary-location",
    "code": "grief-secondary-location-masts",
    "title": "Hoogspanning/zendmasten",
    "description": "Nabijheid van hoogspanningsmasten/lijnen of zendmasten"
  },
  "grief-secondary-energy": {
    "mainCategory": "secondary",
    "category": "energy",
    "platformCategoryCode": "grief-secondary-energy",
    "code": "grief-secondary-energy",
    "title": "Energie",
    "description": ""
  },
  "grief-legal-equality-principle": {
    "mainCategory": "legal",
    "category": "equality-principle",
    "platformCategoryCode": "grief-equality-principle",
    "code": "grief-legal-equality-principle",
    "title": "Gelijkheidsbeginsel",
    "description": "WOZ-vergelijking met buren (WOZ vs WOZ)"
  },
  "grief-legal-reference-objects": {
    "mainCategory": "legal",
    "category": "reference-objects",
    "platformCategoryCode": "grief-reference-objects",
    "code": "grief-legal-reference-objects",
    "title": "Referentieobject",
    "description": "Vergelijking met verkochte woning"
  },
  "grief-other": {
    "mainCategory": "other",
    "platformCategoryCode": "grief-other",
    "code": "grief-other",
    "title": "",
    "description": ""
  },
  "grief-other-water-defense-exemption": {
    "mainCategory": "other",
    "category": "water-defense-exemption",
    "platformCategoryCode": "grief-other-water-defense-exemption",
    "code": "grief-other-water-defense-exemption",
    "title": "Waterverdedigingsvrijstelling",
    "description": "Bezwaar tegen proces/procedure"
  },
  "grief-other-value-too-low": {
    "mainCategory": "other",
    "category": "value-too-low",
    "platformCategoryCode": "grief-other-value-too-low",
    "code": "grief-other-value-too-low",
    "title": "Waarde te laag",
    "description": "Gevoelsmatig bezwaar zonder concrete klacht"
  },
  "grief-other-value-too-high": {
    "mainCategory": "other",
    "category": "value-too-high",
    "platformCategoryCode": "grief-other-value-too-high",
    "code": "grief-other-value-too-high",
    "title": "Waarde te hoog",
    "description": "Algemene discussie over marktwaarde"
  },
  "grief-other-value-relationship": {
    "mainCategory": "other",
    "category": "value-relationship",
    "platformCategoryCode": "grief-other-value-relationship",
    "code": "grief-other-value-relationship",
    "title": "Onderlinge waardeverhouding",
    "description": "Bezwaar tegen verhouding tussen WOZ-waarde en vergelijkbare objecten"
  },
  "grief-other-value-increase": {
    "mainCategory": "other",
    "category": "value-increase",
    "platformCategoryCode": "grief-other-value-increase",
    "code": "grief-other-value-increase",
    "title": "Waardestijging",
    "description": "Bezwaar tegen sterke stijging t.o.v. vorige WOZ-waarde"
  },
  "grief-other-proposed-value": {
    "mainCategory": "other",
    "category": "proposed-value",
    "platformCategoryCode": "grief-other-proposed-value",
    "code": "grief-other-proposed-value",
    "title": "Voorgestelde waarde",
    "description": "Bezwaar tegen door gemeente voorgestelde WOZ-waarde"
  },
  "grief-other-object-boundary": {
    "mainCategory": "other",
    "category": "object-boundary",
    "platformCategoryCode": "grief-other-object-boundary",
    "code": "grief-other-object-boundary",
    "title": "Objectafbakening",
    "description": "Bezwaar over de afbakening van het WOZ-object of perceel"
  },
  "grief-other-market-value": {
    "mainCategory": "other",
    "category": "market-value",
    "platformCategoryCode": "grief-other-market-value",
    "code": "grief-other-market-value",
    "title": "Eigen aankoopcijfer",
    "description": "Bezwaar waarbij de eigen aankoopprijs als uitgangspunt wordt genomen voor de waarde"
  },
  "grief-other-leasehold": {
    "mainCategory": "other",
    "category": "leasehold",
    "platformCategoryCode": "grief-other-leasehold",
    "code": "grief-other-leasehold",
    "title": "Erfpacht",
    "description": "Bezwaar wegens invloed van erfpacht op de waarde"
  },
  "grief-other-hoa-reserve": {
    "mainCategory": "other",
    "category": "hoa-reserve",
    "platformCategoryCode": "grief-other-hoa-reserve",
    "code": "grief-other-hoa-reserve",
    "title": "VvE-reserve",
    "description": "Bezwaar over hoogte of invloed van VvE-reserve op woningwaarde"
  },
  "grief-other-easement": {
    "mainCategory": "other",
    "category": "easement",
    "platformCategoryCode": "grief-other-easement",
    "code": "grief-other-easement",
    "title": "Erfdienstbaarheid",
    "description": "Bezwaar vanwege een erfdienstbaarheid die invloed heeft op de waarde of het gebruik van het object"
  },
  "grief-other-demolition": {
    "mainCategory": "other",
    "category": "demolition",
    "platformCategoryCode": "grief-other-demolition",
    "code": "grief-other-demolition",
    "title": "Sloop",
    "description": "Bezwaar vanwege geplande of uitgevoerde sloop die invloed heeft op de waarde"
  },
  "grief-other-construction": {
    "mainCategory": "other",
    "category": "construction",
    "platformCategoryCode": "grief-other-construction",
    "code": "grief-other-construction",
    "title": "Nieuwbouw/verbouwing",
    "description": "Bezwaar gerelateerd aan recente bouw- of verbouwsituatie"
  },
  "grief-other-asbestos": {
    "mainCategory": "other",
    "category": "asbestos",
    "platformCategoryCode": "grief-other-asbestos",
    "code": "grief-other-asbestos",
    "title": "Asbest",
    "description": "Bezwaar vanwege waardedruk door aanwezige asbest"
  }
} as const;

export type WozCategoryCode = keyof typeof WozCategoriesMap;
export type WozMainCategoryCode = keyof typeof WozMainCategoriesMap;
